'use client';

import Link from '~/shared/components/link';
import NoData from '~/shared/components/no-data';
import { type Locale, PAGE_NAMES } from '~/shared/constants';
import { getLocaleLink } from '~/shared/helpers/browser-helpers';
import type { useTypedTranslation } from '~/shared/hooks';

import type { TopRatedCategoryMenuItem } from '../blog-menu/helpers/blog-menu-cache';
import TopRatedCategoryItem from '../top-rated-category-item';

import './top-rated-categories.scss';

type TopRatedCategoryListItem =
  | TopRatedCategoryMenuItem
  | Readonly<{
      _id: string;
      item: null;
    }>;

type TopRatedCategoriesProps = Readonly<{
  lng: Locale;
  error: boolean;
  loading: boolean;
  items: TopRatedCategoryListItem[];
  t: ReturnType<typeof useTypedTranslation>;
}>;

const TopRatedCategories = ({ lng, items, closeDropdown, loading, error, t }: TopRatedCategoriesProps) => {
  return (
    <nav itemScope itemType="https://schema.org/SiteNavigationElement" className="top-rated-categories">
      <div className="top-rated-categories__title">{t('text.top-5-categories-of-blog')}:</div>

      {items.length > 0 ? (
        <ul className="top-rated-categories__list">
          {items.map(({ _id, item }) => (
            <TopRatedCategoryItem
              closeDropdown={closeDropdown}
              key={_id}
              lng={lng}
              error={error}
              loading={loading}
              item={item}
            />
          ))}
        </ul>
      ) : (
        <NoData variant="web" t={t} />
      )}

      <div className="top-rated-categories__links">
        <Link
          onClick={closeDropdown}
          className="link--underlined"
          itemProp="url"
          href={getLocaleLink(PAGE_NAMES.CATEGORIES, lng)}
        >
          {t('page.categories.menu-item')}
        </Link>

        <Link
          onClick={closeDropdown}
          className="link--underlined"
          itemProp="url"
          href={getLocaleLink(PAGE_NAMES.BLOG, lng)}
        >
          {t('link.go-to-blog')}
        </Link>
      </div>
    </nav>
  );
};

export default TopRatedCategories;
